import styles from './FilterSlider.module.scss'
import Slider from '@/components/inputs/Slider/Slider'
import { FilterType, useFilter } from '@/utils/hooks/useFilter'
import React, { useEffect, useMemo } from 'react'

type Props = {
  property: string,
  label: string,
  items: any[],
  showStartAndEnd?: boolean,
  valueSuffix?: string,
  suffixNewLine?: boolean,
  value?: number[],
  values?: number[],
  step?: number,
  onChange?: (property:string, value: number | number[], filterType: FilterType) => void
}

const FilterSlider = (props: Props) => {
  const { getValuesByPropery } = useFilter(props.items, null)
  const [localValue, setLocalValue] = React.useState<number[] | number | undefined>(props.value || undefined)

  const values = props.values || getValuesByPropery(props.property)

  // get min and max values
  const min = Math.floor(Math.min(...values))
  const max = Math.ceil(Math.max(...values))

  const onChangeHandler = (value: number | number[]) => {
    setLocalValue(value)
  }
  
  const onChangeCommittedHandler = (value: number | number[]) => {
    setLocalValue(value)
    props.onChange?.(props.property, value, FilterType.Slider)
  }

  useEffect(() => {
    let newValue
    if(props.value && props.value.length > 0)
      newValue = props.value
    else if (props.showStartAndEnd)
      newValue = [min, max]
    else
      newValue = max

    setLocalValue(newValue)
  }, [max, min, props.showStartAndEnd, props.value])

  return (
    <div className={styles.component}>
      <label className={styles.label}>
        {props.label}
      </label>
      <Slider
        min={min}
        max={max}
        step={props.step}
        onChange={onChangeHandler}
        onChangeCommitted={onChangeCommittedHandler}
        value={localValue}
        valueSuffix={props.valueSuffix}
      />
    </div>
  )
}

export default FilterSlider